export default "__VITE_ASSET__Bvh9Mrkp__"